import script from "./Assets.vue?vue&type=script&setup=true&lang=js"
export * from "./Assets.vue?vue&type=script&setup=true&lang=js"

import "./Assets.vue?vue&type=style&index=0&id=26294a2c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26294a2c"]])

export default __exports__